import { buttonVariants, cn, Container, Section } from '@resolute/ui';
import { Building2, LineChart, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';


import { Reveal, StaggerGroup, StaggerItem } from '@/components/motion/reveal';

const PILLARS = [
  {
    Icon: LineChart,
    title: 'Yield & ROI intelligence',
    body: 'Gross/net yield, cap rate and EMI-vs-rent modelled on every income asset — decide with numbers, not brochures.',
  },
  {
    Icon: Building2,
    title: 'Pre-leased & GIFT City',
    body: 'Turnkey, tenanted commercial assets in India’s financial SEZ — curated for predictable returns.',
  },
  {
    Icon: ShieldCheck,
    title: 'Verified & RERA-transparent',
    body: 'Every listing carries its RERA number, documents and a verification trail. No surprises.',
  },
];

export function InvestmentTeaser() {
  return (
    <Section spacing="md">
      <Container>
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <Reveal>
            <p className="text-sm font-medium uppercase tracking-widest text-secondary">
              Invest with clarity
            </p>
            <h2 className="mt-2 max-w-md font-display text-display-sm font-semibold tracking-tight">
              Real estate, quantified.
            </h2>
            <p className="mt-4 max-w-md text-lg text-muted-foreground">
              We turn the market&apos;s strongest inventory into a decision you can defend — with
              analytics the listing portals don&apos;t give you.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/invest" className={cn(buttonVariants({ variant: 'primary', size: 'lg' }))}>
                Explore investment assets
              </Link>
              <Link
                to="/calculators/rental-yield"
                className={cn(buttonVariants({ variant: 'outline', size: 'lg' }))}
              >
                Calculate ROI
              </Link>
            </div>
          </Reveal>

          <StaggerGroup className="grid gap-5">
            {PILLARS.map(({ Icon, title, body }) => (
              <StaggerItem key={title} className="flex gap-4 rounded-xl border border-border bg-card p-6">
                <span className="flex size-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon className="size-5" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-medium">{title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{body}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </Container>
    </Section>
  );
}
